import React from 'react';
import { X, Check } from 'lucide-react';
export function Comparison() {
  return <section className="py-20 bg-white" data-id="element-40">
      <div className="max-w-4xl mx-auto px-4" data-id="element-41">
        <div className="text-center mb-12" data-id="element-42">
          <h2 className="text-3xl font-extrabold text-gray-900 mb-4" data-id="element-43">
            ¿Cuánto cuesta NO tenerlo?
          </h2>
        </div>

        <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-200" data-id="element-44">
          <div className="grid grid-cols-2 bg-gray-50 border-b border-gray-200" data-id="element-45">
            <div className="p-6 text-center border-r border-gray-200" data-id="element-46">
              <h3 className="text-lg font-bold text-gray-500" data-id="element-47">
                SIN GIMNASIA 360
              </h3>
            </div>
            <div className="p-6 text-center bg-blue-50" data-id="element-48">
              <h3 className="text-lg font-bold text-blue-700" data-id="element-49">
                CON GIMNASIA 360
              </h3>
            </div>
          </div>

          <div className="divide-y divide-gray-100" data-id="element-50">
            {[{
            bad: 'Horas planificando desde cero cada semana',
            good: '10 minutos. Todo listo.'
          }, {
            bad: 'Clases improvisadas sin progresión',
            good: '+150 progresiones técnicas por nivel'
          }, {
            bad: 'Grupos sin sistema claro de niveles',
            good: 'Estructura clara para cada nivel y objetivo'
          }, {
            bad: 'Alumnas estancadas sin saber por qué',
            good: 'Micro-progresiones para destrabar cualquier elemento'
          }, {
            bad: 'Perder el podio por "detalles" de ejecución',
            good: 'Protocolo de limpieza técnica por aparato'
          }, {
            bad: 'El domingo podés improvisar',
            good: 'o entrar el lunes con todo resuelto.'
          }].map((row, i) => <div key={i} className="grid grid-cols-2" data-id="element-51">
                <div className="p-6 border-r border-gray-100 flex items-start gap-3 bg-red-50/30" data-id="element-52">
                  <X className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-53" />
                  <span className="text-gray-600 text-sm md:text-base" data-id="element-54">
                    {row.bad}
                  </span>
                </div>
                <div className="p-6 flex items-start gap-3 bg-emerald-50/30" data-id="element-55">
                  <Check className="w-5 h-5 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-56" />
                  <span className="text-gray-900 font-medium text-sm md:text-base" data-id="element-57">
                    {row.good}
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        <div className="text-center mt-8" data-id="element-58">
          <p className="text-2xl font-bold text-gray-900 italic" data-id="element-59">
            Vos decidís.
          </p>
        </div>
      </div>
    </section>;
}